import axios from 'axios'

export default {
  search: function (applicantId) {
    return axios.get('/api/vacancy/getApplicantHistoryList?id=' + applicantId)
  },
  find: function (id) {
    return axios.get('/api/vacancy/findApplicantHistory?id=' + id)
  },
  save: function (data) {
    return axios.post('/api/vacancy/saveApplicantHistory', data)
  },  
  delete: function (id) {
    return axios.delete('/api/vacancy/deleteApplicantHistory?id='+id)
  },  
}